import React from 'react';
import { useLocation } from 'react-router-dom';
import VerifyComponent from '../../components/VerifyComponent/VerifyComponent';
import FoveaAILogo from "../../assets/images/foveaai_logo_dark_text.svg";
import './VerifyPage.css';

const VerifyPage = () => {
    const location = useLocation();
    const emailFromState = location.state?.email || '';
    return (
        <div className="VerifyPage">
            <div className="LogoContainer">
                <img className="FoveaAILogo" src={FoveaAILogo} alt="FoveaAI" />
            </div>
            <div className="Slogan">
                Identify top candidates in minutes.
            </div>
            <div className="VerifyArea">
                <h1>Email Verification</h1>
                <p className="VerifyDescription">Please verify your email address to complete your new FoveaAI account creation.</p>
            </div>
            <VerifyComponent initialEmail={emailFromState} />
        </div>
    );
};

export default VerifyPage;